// src/api/shopping.js

import { request } from "/src/utils/index.js";

const CATEGORY_NAME = "商城最新活动";

// 列表查询 (获取字典列表)
export function GetCategoryList(params) {
  return request.get("sys/club/value/list", { params });
}

// 新增商品类型
export function AddCategory(data) {
  return request.post("sys/club/value", data);
}

// 修改商品类型
export function UpdateCategory(data) {
  return request.put("sys/club/value", data);
}

// 删除商品类型
export function DeleteCategory(data) {
  return request.delete("sys/club/value", { data });
}

// 商品类型排序
export function SaveCategoryOrder(data) {
  return request.post("sys/club/value/reorder", data);
}

// 通用获取属性列表
export function GetAttributeList(params) {
  return request.get("sys/club/value/list", { params });
}

// 获取商品列表
export function GetProductList(params) {
  return request.get("/sdbs/mall/product/list", { params });
}

// 获取商品详情
export function GetProductDetail(params) {
  return request.get("/sdbs/mall/product/detail", { params });
}

// 新增商品
export function AddProduct(data) {
  return request.post("/sdbs/mall/product", data);
}

// 更新商品基础信息
export function UpdateProduct(data) {
  return request.put("/sdbs/mall/product", data);
}

// 删除商品
export function DeleteProduct(data) {
  return request.delete("/sdbs/mall/product", { data });
}

// 更新商品上下架状态
export function UpdateProductStatus(data) {
  return request.post("/sdbs/mall/product/enable", data);
}

// 新增规格
export function AddSku(data) {
  return request.post("/sdbs/mall/product/sku", data);
}

// 修改规格
export function UpdateSku(data) {
  return request.put("/sdbs/mall/product/sku", data);
}

// 删除规格
export function DeleteSku(data) {
  return request.delete("/sdbs/mall/product/sku", { data });
}

// 新增附属属性
export function AddProductAttribute(data) {
  return request.post("/sdbs/mall/product/attribute", data);
}

// 修改附属属性
export function UpdateProductAttribute(data) {
  return request.put("/sdbs/mall/product/attribute", data);
}

// 删除附属属性
export function DeleteProductAttribute(data) {
  return request.delete("/sdbs/mall/product/attribute", { data });
}

// 附属属性排序
export function ReorderProductAttribute(data) {
  return request.post("/sdbs/mall/product/attribute/reorder", data);
}

// 获取活动列表
export function GetActivityList(params) {
  const finalParams = { ...params, category: CATEGORY_NAME };
  return request.get("/sys/club/value/list", { params: finalParams });
}

// 新增活动
export function AddActivity(data) {
  const finalData = { ...data, category: CATEGORY_NAME };
  return request.post("/sys/club/value", finalData);
}

// 修改活动
export function UpdateActivity(data) {
  return request.put("/sys/club/value", data);
}

// 删除活动
export function DeleteActivity(data) {
  return request.delete("/sys/club/value", { data });
}

// 活动排序
export function ReorderActivity(idList) {
  return request.post("/sys/club/value/reorder", idList);
}

// ==================== 商城配置管理 (MallSetting) ====================
// 统一使用 /mall/setting 接口，通过 category 区分不同分类

// 查询列表 (GET /mall/setting/list, 传参 excludeEmpty/clubId/category)
export function GetMallSettingList(params) {
  return request.get("mall/setting/list", { params });
}

// 商品展示信息 - 查询列表 (GET /mall/setting/category/product, 传参 category/clubId)
export function GetMallSettingCategoryProduct(params) {
  return request.get("mall/setting/category/product", { params });
}

// 新增数据 (POST /mall/setting)
export function AddMallSetting(data) {
  return request.post("mall/setting", data);
}

// 修改数据 (PUT /mall/setting)
export function UpdateMallSetting(data) {
  return request.put("mall/setting", data);
}

// 删除数据 (DELETE /mall/setting)
export function DeleteMallSetting(data) {
  return request.delete("mall/setting", { data });
}

// 排序接口 (促销品类、商城产品类别)
export function SaveMallSettingOrder(data) {
  return request.post("mall/setting/reorder", data);
}
// ==================== 优惠管理 (Promotion) ====================
// 接口: 14~18
// 优惠类型：满件减额 / 满额减额 / 满额折扣
// 通用：conditionValue 触发条件值，discountValue 优惠值（均为数字）

// 优惠方案列表 (GET /sdbs/promotion/list)
export function GetPromotionList() {
  return request.get("sdbs/promotion/list");
}

// 新增优惠方案 (POST /sdbs/promotion)
export function AddPromotion(data) {
  return request.post("sdbs/promotion", data);
}

// 修改优惠方案 (PUT /sdbs/promotion, 必填 id，其余字段选填，传即更新)
export function UpdatePromotion(data) {
  return request.put("sdbs/promotion", data);
}

// 删除优惠方案 (DELETE /sdbs/promotion, 参数 id)
export function DeletePromotion(data) {
  return request.delete("sdbs/promotion", { data });
}

// 启用禁用优惠方案 (PUT /sdbs/promotion, 必填 id 和 enabled)
export function UpdatePromotionEnabled(data) {
  return request.put("sdbs/promotion", data);
}

// 关联优惠与商品 (POST /sdbs/promotion/product, 参数 promotionId + productIds)
export function AddPromotionProducts(data) {
  return request.post("sdbs/promotion/product", data);
}

// 查询促销已关联商品列表 (GET /sdbs/promotion/product/list, 参数 promotionId)
export function GetPromotionProducts(params) {
  return request.get("sdbs/promotion/product/list", { params });
}

// 删除关联 (DELETE /sdbs/promotion/product, 参数 id 为关联记录 id)
export function DeletePromotionProduct(data) {
  return request.delete("sdbs/promotion/product", { data });
}
